import React from 'react';
import { WeakArea } from '../../../types/learning';
import styles from './RecommendationsSection.module.css';

interface RecommendationsSectionProps {
  weakAreas: WeakArea[];
  onPracticeArea: (category: string) => void;
}

const RecommendationsSection: React.FC<RecommendationsSectionProps> = ({ weakAreas, onPracticeArea }) => {
  if (!weakAreas || weakAreas.length === 0) {
    return (
      <div className={styles.recommendationsSection}>
        <h3>Priority Training Directives</h3>
        <p className={styles.noRecommendations}>Agent, all skill parameters are currently optimal. No specific training directives at this time. Stay sharp!</p>
      </div>
    );
  }

  return (
    <div className={styles.recommendationsSection}>
      <h3>Priority Training Directives</h3>
      <ul className={styles.recommendationsList}>
        {weakAreas.slice(0, 3).map(area => (
          <li key={area.category} className={styles.recommendationItem}>
            <span className={styles.categoryName}>{area.category.charAt(0).toUpperCase() + area.category.slice(1)}</span>
            <div className={styles.performanceBarContainer}>
              <div 
                className={styles.performanceBar}
                style={{ width: `${area.performance}%` }}
                title={`${area.performance}% proficiency`}
              />
            </div>
            <span className={styles.performanceText}>
              {Math.round(area.performance)}%
            </span>
            <button 
              onClick={() => onPracticeArea(area.category)}
              className={styles.practiceButton}
            >
              Engage Training
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(RecommendationsSection); 